<div class="modal-content">
  <form action="#" class="form form-label-right" [formGroup]="frmFilter" (ngSubmit)="filter()">
    <div class="modal-header">
      <div class="modal-title h4">
      Update user role:
      </div>
      <a type="button" class="btn cerrar" aria-label="Close" (click)="modal.dismiss()">✕</a>
    </div>

    <div class="overlay overlay-block cursor-default modal-body">
      <div class="form-group row">
        <div class="col-lg-12">
          <label for="provider" class="form-label">Select role</label>
         
        </div>
      
          <div class="input-group">
            <p-dropdown 
    #ddlPractices 
    [options]="resultRole" 
    (onChange)="onRolesSelected($event)" 
    optionValue="id" 
    optionLabel="name"
    filterBy="name" 
    id="role" 
    formControlName="role" 
    [style]="{'width':'100%'}" 
    placeholder="Select a Role">
</p-dropdown>

          </div>
        </div>
      

      </div>
    

    <!-- <div class="modal-footer">
      <button type="button" class="btn btn-light btn-elevate mr-2"
              (click)="clearFilter()">
        {{ 'GENERAL.CLEAR' | translate }}
      </button>
      <button class="btn btn-success btn-elevate">
        <i class="fa fa-filter"></i> {{ 'GENERAL.APPLY' | translate }}
      </button>
    </div> -->
  </form>
</div>


